export const general_articles = [
    {
        article_link: "https://www.columbiaspectator.com/sports/2026/01/12/in-a-historic-gift-columbia-basketball-receives-10-million-from-jonathan-and-jeannie-lavine/",
        article_title: "In historic gift, Columbia basketball receives $10 million from Jonathan and Jeannie Lavine",
        article_authors: "Kaya Quebada",
        image_url: "https://www.columbiaspectator.com/resizer/v2/VYHELRJAENEUXIYEMNRTMXVEHY.jpg?auth=85631c93d3dfd8bb38d9477a3337bd4a954ec05b22f757e4c9bc14b13399455e"
    },
];